<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link :title="getTitle"></breadcrumb-link>
    <!--内容区域-->
    <div>
      <el-form 
        class="box-detail" 
        label-width="130px" 
        ref="detail"
        :model="detail"
        :disabled="getDisabled"
      >
        <div class="edit-title">基础信息</div>

        <el-form-item 
          label="提交服务名称"
          label-width="250px"
          prop="name"
          :rules="[
            {required: true, message: '必填，不超过50个字符',},
          ]"
        >
          <el-col :span="24">
            <el-input 
              class="main-input"
              placeholder="必填，不超过50个字符"
              maxlength="50"
              show-word-limit 
              v-model="detail.name"
            ></el-input>
          </el-col>
        </el-form-item>


        <el-form-item 
          label="pipeline名称:" 
          label-width="250px"
          prop="pipelineId" 
          :rules="[
            {required: true, message: '请选择pipeline名称'}
          ]"
        >
          <el-select 
            v-model="detail.pipelineId" 
            filterable 
            :placeholder="detail.pipelineName"
            valye-key="id"
          >
            <el-option 
              v-for="(itm, idx) in pipelineList" 
              :key="idx" 
              :label="itm.name"
              :value="itm.id"

              ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运行实例主机地址:" label-width="250px" prop="hostName" :rules="[
            {required: true, message: '必填'},
          ]">
          <el-input placeholder="请输入运行实例主机地址" style="width:600px" v-model="detail.hostName"></el-input>
        </el-form-item>
        <el-form-item label="HDFS中ODS层的绝对路径:" label-width="250px" prop="odsStorePath" :rules="[
            {required: true, message: '必填'},
          ]">
          <el-input placeholder="请输入HDFS中ODS层的绝对路径" style="width:600px" v-model="detail.odsStorePath"></el-input>
        </el-form-item>
        <el-form-item label="提交文件的并行度:" label-width="250px" prop="submitParallelism" :rules="[
            {required: true, message: '必填'},
          ]">
          <el-input-number v-model="detail.submitParallelism" controls-position="right"></el-input-number>
        </el-form-item>

        <el-form-item label="扫描文件的并行度:" label-width="250px" prop="scanParallelism" :rules="[
            {required: true, message: '必填'},
          ]">
          <el-input-number v-model="detail.scanParallelism" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="扫描与提交的执行间隔:" label-width="250px" prop="submitInterval" :rules="[
            {required: true, message: '必填,不能为0'},
          ]">
          <el-input
            type="number"
            style="width:182px"
            v-model="detail.submitInterval">
            <i slot="suffix">min</i>
          </el-input>
        </el-form-item>
        <div v-if=" type =='details'">
          <history-record
            :historyTitle="historyTitle"
            :historyList="historyList"/>
        </div>
      </el-form>
      <div style="padding-left: 130px">
        <el-button
          type="primary"
          @click="submitForm('detail')" v-if="type!='details'">保存
        </el-button>
        <el-button type="info" plain @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import util from '@/utils/util';
  import HistoryRecord from '../../../components/common/historyRecord';

  import {
    addService,
    getServiceInfo,
    getPipelineNList,
  } from '@/apis/pipelineService/pipelineConfig';

  export default {
    components: {
      HistoryRecord,
      BreadcrumbLink,
    },
    data() {
      return {
        type: '', // 跳转页面获取标题
        detail: {
          name: '',  // pipeline名称
          pipelineId: '',
          odsStorePath: '',
          submitParallelism: 20,
          scanParallelism: 20,
          submitInterval: 5,
          hostName: ''
        },
        setOptions: {},
        pipelineList: [],
        historyTitle: '记录信息', // 记录信息标题
        historyList: [], // 记录信息信息内容

        id: this.$route.query.id,
        virtualGlobalStatus: this.$route.query.virtualGlobalStatus,
      };
    },
    computed: {
      getDisabled() {
        return {
          'add': false,
          'edit': false,
          'details': true
        }[this.type];
      },
      getTitle() {
        return {
          'add': '新增提交服务配置',
          'edit': '修改提交服务配置',
          'details': '提交服务配置详情'
        }[this.type];
      },
      treeList() {
        return getCityTreeList(this.type !== 'details' ? 'add' : 'details')
      },
    },
    mounted() {
      this.type = this.$route.query.type;
      
      if (this.type != 'add') {
        this.getDetails();
      }else {
        this.getPipelineNList()
      }
    },
    methods: {
      // 返回上一层
      goBack() {
        this.$router.go(-1);
      },
      // 详情
      async getDetails() {
        let params = {
          id: this.id,
        };
        try {
          const data = await getServiceInfo(params);
          if (data.code == 0 && data.data) {
            this.detail = data.data;
            this.getPipelineNList(this.detail.pipelineId)
            this.historyList = [
            {
              label: '创建人：',
              value: data.data.creatorName,
            }, {
              label: '创建时间：',
              value: data.data.createTime.replace(/T/g,' '),
            },
            {
              label: '最后修改人：',
              value: data.data.updatorName,
            }, {
              label: '修改时间：',
              value: data.data.updateTime.replace(/T/g,' '),
            }];
          }else {
            this.$message.success(data.message)
          }
        } catch (error) {
        }
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.pushForm();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 提交
      async pushForm() {
        let params = {
          ...this.detail
        };
        if (this.type == 'add') {
          delete params.id;
        }
        try {
          const data = await addService(params);
          if (data.code == 0) {
            this.$router.go(-1);
            this.$message.success(data.message);
          } else {
            this.$message.error(data.message);
          }
        } catch (error) {
        }
      },
      // 获取source列表
      async getPipelineNList(pipelineId) {
        let params = {
          // current: 1,
          // size: 100,
          usedStatus: 'N',
          pipelineId
        };
        try {
          const data = await getPipelineNList(params)
          if (data.code == 0 && data.data) {
            this.pipelineList = data.data;
          }else {
            this.$message.error(data.message)
          }
        } catch (error) {
        }
      },
    }
  };
</script>

<style scoped lang="scss">
  .box-detail {
    width: 850px;
    .main-input {
      width: 400px;
    }
  }
  
</style>
